import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useScrolled } from "../hooks/useScrolled";
import { DesktopNav } from "./navbar/DesktopNav";
import { MobileMenu } from "./navbar/MobileMenu";

export const Navbar = () => {
    const scrolled = useScrolled();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    // Home has a full-bleed hero, so the bar starts transparent there.
    // Every other route has content beneath the bar, so keep it solid.
    const solid = scrolled || pathname !== "/";

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
                solid
                    ? "bg-white/70 backdrop-blur-xl border-b border-black/10"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[68px] flex items-center justify-between">
                <button
                    data-testid="nav-logo"
                    onClick={() => {
                        navigate("/");
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="flex items-center group"
                >
                    <img
                        src="/FRANKEL-lockup.png"
                        alt="FRANKEL"
                        className="h-10 sm:h-11 w-auto object-contain transition-transform group-hover:scale-[1.03]"
                    />
                </button>

                <DesktopNav />

                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden text-black"
                    onClick={() => setOpen(!open)}
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </nav>

            {open && <MobileMenu onNavigate={() => setOpen(false)} />}
        </header>
    );
};
